<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2" id="calibre_pb_0"></div>
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Danksagung</span></h1>
<p class="p_normal"> </p>
<p class="p_normal"> </p>
<p class="p_norm-noindent"><span class="calibre3">WIE IMMER:</span> Ein Dankeschön an Lynn und Poppy dafür, dass sie die Dinge in Ordnung gebracht haben.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?3073d3ca